<style lang="less" scoped>
    .menu-tree {
        margin: 30px 0 0 0;
    }
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="角色名称" prop="roleName">
                                <el-input v-model="detailForm.roleName" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="角色描述" prop="described">
                                <el-input type="textarea" v-model="detailForm.described" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="功能权限">
                                <!-- <el-tree :data="menuList" class="menu-tree" show-checkbox @check-change="onCheckChange"></el-tree> -->
                                <Tree :data="menuList" class="menu-tree" show-checkbox @on-check-change="onCheckChange"></Tree>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageTitle: '角色新增',
                // 默认值设置
                detailForm: {},
                pageConfig: pageConfig,
                editFlag: false,
                menuList: [],
                selMenus: [],
                roleMenuList: []
            }
        },
        methods: {
            init() {
                // 菜单列表
                console.log(this.$store.state.userInfo)
                if (this.$store.state.editId) {
                    this.editFlag = true;
                    this.pageTitle = "角色编辑";
                    this.getFormInfo();
                    this.getRoleMenu(this.$store.state.editId);
                } else {
                    this.getMenuList();
                }
            },
            // 获取表单信息
            getFormInfo() {
                let _ = this;
                _.$S.getFormInfo(_, _.$A.role.list + '/' + _.$store.state.editId, function(res) {
                    _.detailForm = res.data.data;
                    _.getMenuList();
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.roleType= '03';
                _.detailForm.roleTypeName= '4.0_saas'
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.detailForm.corpNo = _.$store.state.corpNo;
                        _.detailForm.menuIds = _.selMenus;
                        _.detailForm.dealerNo = _.$store.state.userInfo.dealNo;
                        _.$S.submitForm(_, _.$A.role.list, _.editFlag, _.detailForm, pageConfig.listRouter);
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            },
            // 菜单选择
            onCheckChange(val) {
                this.selMenus = [];
                var _this = this;
                val.forEach((item) => {
                    if (item.level === 2) {
                        var inArr = $.inArray(item.pid, _this.selMenus) >= 0 ? true : false;
                        if (inArr === false) {
                            this.selMenus.push(item.pid);
                        }
                    //     this.menuList.forEach(it=>{
                    //     // console.log(1);
                    //         it.children.forEach(i=>{
                    //             console.log(1);
                    //             if(it.parentCode == i.menuCode){
                    //                 // console.log(1);
                    //                 this.selMenus.push(it.id);
                    //             }
                    //         })
                        
                    //    })
                    }
                    this.selMenus.push(item.id);
                });
            },
            getMenuList() {
                // 所有的菜单列表
                var _this = this;
                var flag = -1;
                _this.$H.post(_this, _this.$A.menu.allList, {}).then(function(res) {
                    var dbList = res.data.data;
                    var sortList = dbList.sort(_this.$U.compare('sort'));
                    _this.menuList = [];
                    sortList.forEach((item, index) => {
                        // var checked = $.inArray(item.id, _this.defaultList) >= 0 ? true : false;
                        // if (item.menuLevel === 1) {
                        //     checked = false;
                        //     _this.menus.push(item.id);
                        // }
                        // if (checked) {
                        //     _this.menus.push(item.id);
                        // }
                        // let p = {
                        //     title: item.menuNameZh,
                        //     id: item.id,
                        //     level: item.menuLevel,
                        //     pid: item.pId,
                        //     expand: checked,
                        //     children: [],
                        //     checked: checked
                        // };
                        // if (item.pId === 0 || item.pId === '0') {
                        //     flag++;
                        //     _this.menuList.push(p);
                        // } else {
                        //     _this.menuList[flag].children.push(p);
                        // }
                        if (item.targetUrl == 'PILE4_SASS') {
                            var checked = $.inArray(item.id, _this.roleMenuList) >= 0 ? true : false;
                            if (item.menuClass === 'hasChild' && item.menuLevel === 1) {
                                checked = false;
                                _this.selMenus.push(item.id);
                            }
                            if (checked) {
                                _this.selMenus.push(item.id);
                            }
                            let p = {
                                title: item.menuNameZh,
                                id: item.id,
                                level: item.menuLevel,
                                pid: item.parentCode,
                                expand: checked,
                                children: [],
                                checked: checked
                            };
                            if (item.pId === '0' || item.pId === 0) {
                                flag++;
                                _this.menuList.push(p);
                            } else {
                                _this.menuList[flag].children.push(p);
                            }
                            // if (item.parentCode === '' || item.parentCode === null) {
                            //     flag++;
                            //     _this.menuList.push(p);
                            // } else {
                            //     _this.menuList[flag].children.push(p);
                            // }
                        }
                    });
                });
            },
            // 获取角色菜单
            getRoleMenu(roleId) {
                var _this = this;
                _this.roleMenuList = [];
                var url = _this.$A.role.listmenu;
                _this.$H.post(_this, url, {
                    roleId: roleId
                }).
                then(response => {
                    response.data.data.forEach((item, index) => {
                        _this.roleMenuList.push(item.id);
                    });
                    // 初始化菜单
                    _this.getMenuList();
                });
            },
        },
        mounted() {
            // 面包屑配置
            this.$store.commit('setBreadCrumbList', pageConfig.detailBreadCrumb);
            this.init();
        }
    }
</script>